module.exports = __webpack_public_path__ + "eddc023d3625e6b1ccac42c0c1ad3605.pdf";